import Alpine from 'alpinejs'
import "~/entrypoints/src/global"

window.Alpine = Alpine

window.Alpine.start()
